// CarSection.tsx
import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

// Swiper core styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import axiosInstance from "../../../axiosInstance";
import axios from "axios";
import { Link } from "react-router-dom";

const cars = [
  {
    id: 1,
    badge: "Low Mileage",
    images: [
      "images/resource/shop3-1.jpg",
      "images/resource/shop3-2.jpg",
      "images/resource/shop3-3.jpg",
    ],
    link: "inventory-page-single-v2.html",
    title: "Mercedes-Benz, C Class",
    desc: "2023 C300e AMG Line Night Ed Premiu...",
    miles: "72,925 miles",
    fuel: "Petrol",
    transmission: "Automatic",
  },
  {
    id: 2,
    badge: null,
    images: [
      "images/resource/shop3-2.jpg",
      "images/resource/shop3-3.jpg",
      "images/resource/shop3-1.jpg",
    ],
    link: "inventory-page-single-v3.html",
    title: "Mercedes-Benz, C Class",
    desc: "2023 C300e AMG Line Night Ed Premiu...",
    miles: "72,925 miles",
    fuel: "Petrol",
    transmission: "Automatic",
  },
  {
    id: 3,
    badge: "Great Price",
    images: [
      "images/resource/shop3-3.jpg",
      "images/resource/shop3-2.jpg",
      "images/resource/shop3-1.jpg",
    ],
    link: "inventory-page-single-v4.html",
    title: "Mercedes-Benz, C Class",
    desc: "2023 C300e AMG Line Night Ed Premiu...",
    miles: "72,925 miles",
    fuel: "Petrol",
    transmission: "Automatic",
  },
  {
    id: 4,
    badge: null,
    images: [
      "images/resource/shop3-4.jpg",
      "images/resource/shop3-5.jpg",
      "images/resource/shop3-2.jpg",
    ],
    link: "inventory-page-single-v5.html",
    title: "Mercedes-Benz, C Class",
    desc: "2023 C300e AMG Line Night Ed Premiu...",
    miles: "72,925 miles",
    fuel: "Petrol",
    transmission: "Automatic",
  },
  {
    id: 5,
    badge: "Low Mileage",
    images: [
      "images/resource/shop3-1.jpg",
      "images/resource/shop3-5.jpg",
      "images/resource/shop3-2.jpg",
    ],
    link: "inventory-page-single-v5.html",
    title: "Mercedes-Benz, C Class",
    desc: "2023 C300e AMG Line Night Ed Premiu...",
    miles: "72,925 miles",
    fuel: "Petrol",
    transmission: "Automatic",
  },
  {
    id: 6,
    badge: null,
    images: [
      "images/resource/shop3-2.jpg",
      "images/resource/shop3-5.jpg",
      "images/resource/shop3-2.jpg",
    ],
    link: "inventory-page-single-v4.html",
    title: "Mercedes-Benz, C Class",
    desc: "2023 C300e AMG Line Night Ed Premiu...",
    miles: "72,925 miles",
    fuel: "Petrol",
    transmission: "Automatic",
  },
  {
    id: 7,
    badge: "Great Price",
    images: [
      "images/resource/shop3-3.jpg",
      "images/resource/shop3-5.jpg",
      "images/resource/shop3-2.jpg",
    ],
    link: "inventory-page-single-v5.html",
    title: "Mercedes-Benz, C Class",
    desc: "2023 C300e AMG Line Night Ed Premiu...",
    miles: "72,925 miles",
    fuel: "Petrol",
    transmission: "Automatic",
  },
  {
    id: 8,
    badge: null,
    images: [
      "images/resource/shop3-4.jpg",
      "images/resource/shop3-5.jpg",
      "images/resource/shop3-2.jpg",
    ],
    link: "inventory-page-single.html",
    title: "Mercedes-Benz, C Class",
    desc: "2023 C300e AMG Line Night Ed Premiu...",
    miles: "72,925 miles",
    fuel: "Petrol",
    transmission: "Automatic",
  },
];

export default function CarSection() {
  const tabs = ["Used","Sold"]
  const [selectedTab,setSelectedTab] = useState("Used")
  const [loading,setLoading] = useState(false)
  const [error,setError] = useState("")
  const [inventories,setInventories] = useState([])
  const getAllInventory = async(selected) => {
    try {
      setLoading(true)
      setError("")
      const response = await axiosInstance.get(`/api/public/getInventories`,{
        params:{flag:selected}
      })
      console.log(response?.data?.message);
      setInventories(response?.data?.data);
    } catch (error) {
       if (axios.isAxiosError(error)) {
        if (error.response) {
          const msg = error.response.data?.message || error.response.data?.error || "Something went wrong on the server.";
          setError(msg);
        }
        else if (error.request) {
          setError("No response from server. Please check your internet connection.");
        }
        else {
          setError(error.message || "Unexpected error occurred.");
        }
      } else {
        setError("An unexpected error occurred.");
      }
    } finally{
      setLoading(false)
    }
  }
  useEffect(()=>{
    getAllInventory(selectedTab)
  },[selectedTab]) 
  return (
    <section style={{paddingTop:"0px"}} className="cars-section-three">
      {/* Header + Tabs */}
      <div className="boxcar-container">
        <div className="boxcar- wow fadeInUp">
          <h2>Explore All Vehicles</h2>
          <Link to={'/Inventory'} style={{float:"right", cursor:"pointer"}} className="btn-title">
            View All
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={14}
              height={14}
              viewBox="0 0 14 14"
              fill="none"
            >
              <g clipPath="url(#clip0_601_243)">
                <path
                  d="M13.6109 0H5.05533C4.84037 0 4.66643 0.173943 4.66643 0.388901C4.66643 0.603859 4.84037 0.777802 5.05533 0.777802H12.6721L0.113697 13.3362C-0.0382246 13.4881 -0.0382246 13.7342 0.113697 13.8861C0.18964 13.962 0.289171 14 0.388666 14C0.488161 14 0.587656 13.962 0.663635 13.8861L13.222 1.3277V8.94447C13.222 9.15943 13.3959 9.33337 13.6109 9.33337C13.8259 9.33337 13.9998 9.15943 13.9998 8.94447V0.388901C13.9998 0.173943 13.8258 0 13.6109 0Z"
                  fill="#050B20"
                />
              </g>
              <defs>
                <clipPath id="clip0_601_243">
                  <rect width={14} height={14} fill="white" />
                </clipPath>
              </defs>
            </svg>
          </Link>
          {error && <span style={{fontSize:"18px",color:"red"}}>{error}</span>}
        </div>
        <nav className="wow fadeInUp" data-wow-delay="100ms">
          <div className="nav nav-tabs" id="nav-tab" role="tablist">
            {tabs.map((tab,index)=><button key={index}
              className={selectedTab===tab?"nav-link active":"nav-link"}
              id={`nav-${tab}-tab`}
              data-bs-toggle="tab"
              data-bs-target={`#nav-${tab}`}
              type="button"
              role="tab"
              aria-controls={`nav-${tab}`}
              onClick={()=>setSelectedTab(tab)}
              aria-selected="true"
            >
              {tab} cars
            </button>)}
          </div>
        </nav>
      </div>

      {/* Tab Content */}
      {loading? <p>Loading....</p>:<div
        className="tab-content wow fadeInUp"
        data-wow-delay="200ms"
        id="nav-tabContent"
      >
        {/* New Cars Tab */}
        <div
          className="tab-pane fade show active"
          id={`nav-${selectedTab}`}
          role="tabpanel"
          aria-labelledby={`nav-${selectedTab}-tab`}>
          <div className="car-slider-three slider-layout-1">
            <Swiper
              modules={[Navigation]}
              spaceBetween={30}
              autoplay={{ delay: 4000, disableOnInteraction: false }}
              pagination={{ clickable: true }}
              breakpoints={{
                576: { slidesPerView: 2 },
                768: { slidesPerView: 1 },
                992: { slidesPerView: 3 },
              }}
              navigation={{
                prevEl: ".swiper-prevvv",
                nextEl: ".swiper-nexttt",
              }}
            >
              {inventories.length === 0?<div>
                  <h3>No cars Found</h3>
                </div>:inventories.map((car,index) => (
                <SwiperSlide key={index}>
                  <CarCard2 car={car}/>
                  
                </SwiperSlide>
              ))}
            </Swiper>
            <button className="swiper-prevvv slick-arrow" aria-label="Previous">
              <FaChevronLeft size={18} />
            </button>
            <button className="swiper-nexttt slick-arrow" aria-label="Next">
              <FaChevronRight size={18} />
            </button>
          </div>
        </div>
      </div>}
    </section>
  );
}

/* =============================================================== */
/* Car Card with Inner Image Slider                                */
/* =============================================================== */
function CarCard({
  id,
  badge,
  images,
  link,
  title,
  desc,
  miles,
  fuel,
  transmission,
  key
}) {
  return (
    <div className="box-car car-block-three">
      <div className="inner-box">
        {/* Image Box with Swiper + Custom Slick Dots */}
        <div className={`image-box ${badge ? "two" : ""}`}>
          <Swiper
            modules={[Autoplay ,Pagination]}
            autoplay={{ delay: 4000, disableOnInteraction: false }}
            loop={true}
            pagination={{
              clickable: true,
              el: `.slick-dots-${id}`, // Unique class per card
              type: "bullets",
              renderBullet: (index, className) => {
                return `<li className="${className}" role="presentation">
                  <button type="button" role="tab" aria-label="${
                    index + 1
                  } of ${images.length}" tabindex="0">
                    ${index + 1}
                  </button>
                </li>`;
              },
            }}
            className="slider-thumb"
          >
            {images.map((src, i) => (
              <SwiperSlide key={i}>
                <div className="image">
                  <a href="#">
                    <img src={src} alt={`${title} ${i + 1}`} />
                  </a>
                </div>
              </SwiperSlide>
            ))}

            {/* Custom Arrows */}
            <div className="swiper-button-prev thumb-prev" />
            <div className="swiper-button-next thumb-next" />
          </Swiper>

          {/* Slick-style Dots (outside Swiper, controlled via el) */}
          <ul
            className={`slick-dots slick-dots-${id}`}
            style={{ display: "block" }}
            role="tablist"
          />

          {badge && <span>{badge}</span>}

          <a href="#" className="icon-box">
            {/* Bookmark SVG */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={12}
              height={12}
              viewBox="0 0 12 12"
              fill="none"
            >
              <g clipPath="url(#clip0_601_1274)">
                <path
                  d="M9.39062 12C9.15156 12 8.91671 11.9312 8.71128 11.8009L6.11794 10.1543C6.04701 10.1091 5.95296 10.1096 5.88256 10.1543L3.28869 11.8009C2.8048 12.1082 2.13755 12.0368 1.72722 11.6454C1.47556 11.4047 1.33685 11.079 1.33685 10.728V1.2704C1.33738 0.570053 1.90743 0 2.60778 0H9.39272C10.0931 0 10.6631 0.570053 10.6631 1.2704V10.728C10.6631 11.4294 10.0925 12 9.39062 12ZM6.00025 9.06935C6.24193 9.06935 6.47783 9.13765 6.68169 9.26743L9.27503 10.9135C9.31233 10.9371 9.35069 10.9487 9.39114 10.9487C9.48046 10.9487 9.61286 10.8788 9.61286 10.728V1.2704C9.61233 1.14956 9.51356 1.05079 9.39272 1.05079H2.60778C2.48642 1.05079 2.38817 1.14956 2.38817 1.2704V10.728C2.38817 10.7911 2.41023 10.8436 2.45384 10.8851C2.52582 10.9539 2.63563 10.9708 2.72599 10.9135L5.31934 9.2669C5.52267 9.13765 5.75857 9.06935 6.00025 9.06935Z"
                  fill="black"
                />
              </g>
              <defs>
                <clipPath id="clip0_601_1274">
                  <rect width={12} height={12} fill="white" />
                </clipPath>
              </defs>
            </svg>
          </a>
        </div>

        {/* Content Box */}
        <div className="content-box">
          <h6 className="title">
            <a href={link}>{title}</a>
          </h6>
          <div className="text">{desc}</div>

          <ul>
            <li>
              <i className="flaticon-gasoline-pump" />
              {miles}
            </li>
            <li>
              <i className="flaticon-speedometer" />
              {fuel}
            </li>
            <li>
              <i className="flaticon-gearbox" />
              {transmission}
            </li>
          </ul>

          <div className="btn-box">
            <span>$789</span>
            <small>$399</small>
            <a href="#" className="details">
              View Details
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={14}
                height={14}
                viewBox="0 0 14 14"
                fill="none"
              >
                <g clipPath="url(#clip0_601_4346)">
                  <path
                    d="M13.6109 0H5.05533C4.84037 0 4.66643 0.173943 4.66643 0.388901C4.66643 0.603859 4.84037 0.777802 5.05533 0.777802H12.6721L0.113697 13.3362C-0.0382246 13.4881 -0.0382246 13.7342 0.113697 13.8861C0.18964 13.962 0.289171 14 0.388666 14C0.488161 14 0.587656 13.962 0.663635 13.8861L13.222 1.3277V8.94447C13.222 9.15943 13.3959 9.33337 13.6109 9.33337C13.8259 9.33337 13.9998 9.15943 13.9998 8.94447V0.388901C13.9998 0.173943 13.8258 0 13.6109 0Z"
                    fill="#405FF2"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_601_4346">
                    <rect width={14} height={14} fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

function CarCard2({car}) {
  const message = encodeURIComponent(
  "Hello! I am interested in this car. Please share more details."
);
  
  return (
    <div className="box-car car-block-three">
      <div className="inner-box">
        {/* Image Box with Swiper + Custom Slick Dots */}
        <div className={`image-box ${car.flag ? "two" : ""}`}>
          <Swiper
            modules={[Navigation]}
                navigation={{
                                         prevEl: ".custom-prev",
                                         nextEl: ".custom-next",
                                       }}
            
            className="slider-thumb"
          >
            {car.media.map((obj, i) => (
              <SwiperSlide key={i}>
                <div className="image">
                  <a href="#">
                    <img style={{height:"200px"}} src={obj.path} alt={`${i + 1}`} />
                  </a>
                </div>
              </SwiperSlide>
            ))}

            {/* Custom Arrows */}
            <button style={{position:"absolute" , top:"40%", color:"black", border:"1px solid white", backgroundColor:"#f3f3f3", opacity:"0.8" }} className="swiper-prevv custom-prev slick-arrow" aria-label="Previous">
                                                                 <FaChevronLeft size={18} />
                                                               </button>
                                                               <button style={{position:"absolute" , top:"40%", color:"black", border:"1px solid white", backgroundColor:"#f3f3f3", opacity:"0.8" }} className="swiper-nextt custom-next slick-arrow" aria-label="Next">
                                                                 <FaChevronRight size={18} />
                                                               </button>
          </Swiper>

          {/* Slick-style Dots (outside Swiper, controlled via el) */}
          <ul
            className={`slick-dots slick-dots-${car._id}`}
            style={{ display: "block" }}
            role="tablist"
          />

          {car.flag && <span>{car.flag}</span>}

          <a href="#" className="icon-box">
            {/* Bookmark SVG */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={12}
              height={12}
              viewBox="0 0 12 12"
              fill="none"
            >
              <g clipPath="url(#clip0_601_1274)">
                <path
                  d="M9.39062 12C9.15156 12 8.91671 11.9312 8.71128 11.8009L6.11794 10.1543C6.04701 10.1091 5.95296 10.1096 5.88256 10.1543L3.28869 11.8009C2.8048 12.1082 2.13755 12.0368 1.72722 11.6454C1.47556 11.4047 1.33685 11.079 1.33685 10.728V1.2704C1.33738 0.570053 1.90743 0 2.60778 0H9.39272C10.0931 0 10.6631 0.570053 10.6631 1.2704V10.728C10.6631 11.4294 10.0925 12 9.39062 12ZM6.00025 9.06935C6.24193 9.06935 6.47783 9.13765 6.68169 9.26743L9.27503 10.9135C9.31233 10.9371 9.35069 10.9487 9.39114 10.9487C9.48046 10.9487 9.61286 10.8788 9.61286 10.728V1.2704C9.61233 1.14956 9.51356 1.05079 9.39272 1.05079H2.60778C2.48642 1.05079 2.38817 1.14956 2.38817 1.2704V10.728C2.38817 10.7911 2.41023 10.8436 2.45384 10.8851C2.52582 10.9539 2.63563 10.9708 2.72599 10.9135L5.31934 9.2669C5.52267 9.13765 5.75857 9.06935 6.00025 9.06935Z"
                  fill="black"
                />
              </g>
              <defs>
                <clipPath id="clip0_601_1274">
                  <rect width={12} height={12} fill="white" />
                </clipPath>
              </defs>
            </svg>
          </a>
        </div>

        {/* Content Box */}
        <div style={{paddingBottom:"30px"}} className="content-box">
          <h6 className="title">
            <a>{car.title}</a>
          </h6>
          <div className="text" style={{wordWrap:"break-word",textWrap:"wrap"}}>{car?.carDetails?.description?.slice(0,100)}</div>

          <ul>
            <li>
              <i className="flaticon-gasoline-pump" />
              {car?.carDetails?.mileage}
            </li>
            <li>
              <i className="flaticon-speedometer" />
              {car?.carDetails?.fuelType}
            </li>
            <li>
              <i className="flaticon-gearbox" />
              {car?.carDetails?.transmission}
            </li>
          </ul>

          <div className="btn-box">
            <span>₹{car?.price?.amount}</span>
            <small>₹{car?.price?.totalPrice}</small>
            <a style={{position:"absolute", bottom:"28%"}} href="#" className="details">
              View Details
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={14}
                height={14}
                viewBox="0 0 14 14"
                fill="none"
              >
                <g clipPath="url(#clip0_601_4346)">
                  <path
                    d="M13.6109 0H5.05533C4.84037 0 4.66643 0.173943 4.66643 0.388901C4.66643 0.603859 4.84037 0.777802 5.05533 0.777802H12.6721L0.113697 13.3362C-0.0382246 13.4881 -0.0382246 13.7342 0.113697 13.8861C0.18964 13.962 0.289171 14 0.388666 14C0.488161 14 0.587656 13.962 0.663635 13.8861L13.222 1.3277V8.94447C13.222 9.15943 13.3959 9.33337 13.6109 9.33337C13.8259 9.33337 13.9998 9.15943 13.9998 8.94447V0.388901C13.9998 0.173943 13.8258 0 13.6109 0Z"
                    fill="#405FF2"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_601_4346">
                    <rect width={14} height={14} fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </a>
          </div>
          <div style={{ width:"100%", display:"inline-block", height:"30px", paddingTop:"25px", padding:"20px", paddingBottom:"10px"}} >
                      <a style={{ height:"54px", textAlign:"center", width:"100%",  display:"inline-block", backgroundColor:"white", border:"1px solid #60C961", borderRadius:"20px", color:"#60C961", padding:"10px" }}   target="_blank" href={`https://wa.me/14165626307?text=${message?message:""}`} className="side-btn two">
                        Chat Via Whatsapp
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={14}
                          height={14}
                          viewBox="0 0 14 14"
                          fill="none"
                        >
                          <g clipPath="url(#clip0_881_8744)">
                            <path
                              d="M13.6111 0H5.05558C4.84062 0 4.66668 0.173943 4.66668 0.388901C4.66668 0.603859 4.84062 0.777802 5.05558 0.777802H12.6723L0.113941 13.3362C-0.0379805 13.4881 -0.0379805 13.7342 0.113941 13.8861C0.189884 13.962 0.289415 14 0.38891 14C0.488405 14 0.5879 13.962 0.663879 13.8861L13.2222 1.3277V8.94447C13.2222 9.15943 13.3962 9.33337 13.6111 9.33337C13.8261 9.33337 14 9.15943 14 8.94447V0.388901C14 0.173943 13.8261 0 13.6111 0Z"
                              fill="#60C961"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_881_8744">
                              <rect width={14} height={14} fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </a>
                    </div>
        </div>
      </div>
    </div>
  );
}
